import axios from "axios";
import Cookies from "js-cookie";
import { TFileUploadFailResponse, TFileUploadResponse } from "types/ResponseTypes";

export type ImportVariant = "participant" | "contract" | "invoice" | "platform" | "statistics";
export type ApiVersion = "v1" | "v2";

export const importFunction = (file: FormData, variant: ImportVariant, version?: ApiVersion) => {
  return axios
    .post(`/api/${version || 'v1'}/${variant}/import/xls/`, file, {
      headers: {
        "X-CSRFToken": Cookies.get("csrftoken"),
        "Content-Type": "multipart/form-data",
        "Content-Disposition": "attachment"
      }
    })
    .then(({ data }: { data: TFileUploadResponse }) => data)
    .catch(({ response: { data } }: { response: { data: TFileUploadFailResponse } }) => {
      throw typeof data === "string"
        ? { error_message: "Произошла ошибка. Повторите позже." }
        : data;
    });
};
